import URI from 'urijs';

let isDebug = new URI(location.href).query(true).isDebug;
if (isDebug === "false") {
  window.isDebug = false;
} else if (isDebug === "true") {
  window.isDebug = true;
}
import './template/css/app.css';
import './template/css/default.css';
import './template/css/index.css';
import './core/passiveEvent';
import PullDownRefresh from './components/pullDownRefresh/pullDownRefresh';
import './core/disableChromePullToRefresh';
import './core/keyboard';
import 'url-polyfill';
// pwa support
import './core/error';
import * as offlineRuntime from 'offline-plugin/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import FastClick from 'fastclick';
import router from './core/router';
import history from './core/appHistory';
import './core/api/wxApi';
import './pages/index';
import tabbar from './core/tabbar';
import header from './core/header';
import uniqueId from 'lodash/uniqueId';
import last from 'lodash/last';
import {animationEnd, isX5App} from 'core/utils';
import pageLoader from './core/framework/loader';
console.log(pageLoader);
// Loaded with utils/routes-loader.js
let routes = require('./routes.json');
window.routes = routes;
var errorCount = 0;
var badgeStyle = null;
// Enable Hot Module Replacement (HMR)
if (module.hot && !window.inited) {
  if (!(window.localStorage && localStorage.getItem("noVConsole") == "true")) {
    let vConsole = require("vconsole/dist/vconsole.min.js");
    new vConsole();
  }
  // let overlay = require("./core/webpack-client-overlay-closeable");
  if (typeof window.onerror === "function") {
    window.oldonerror = window.onerror;
  }
  window.onload = function (event) {
    if (document.querySelector('.vc-switch')) {
      document.querySelector('.vc-switch').innerText = "..."
    }
  }
  window.onerror = function (msg, url, line, col, error) {
    errorCount += 1;
    if (badgeStyle) {
      document.getElementsByTagName("head")[0].removeChild(badgeStyle);
    }
    setTimeout(function () {
      badgeStyle = document.createElement("style");
      badgeStyle.setAttribute("type", "text/css");
      badgeStyle.innerText = ".vc-badge:after{content:'" + errorCount + "';}";
      document.getElementsByTagName("head")[0].appendChild(badgeStyle);
      if (document.querySelector('.vc-switch')) {
        document.querySelector('.vc-switch').classList.add("vc-badge");
        document.querySelector('.vc-switch').classList.add('vc-shock');
        document.querySelector('.vc-switch').style["background-color"] = "";
        document.querySelector('.vc-switch').innerText = "检测到资源发生错误，请检查。共  " + errorCount + " 处错误";
        clearTimeout(window.errorTimer);
        window.errorTimer = setTimeout(function () {
          document.querySelector('.vc-switch').classList.remove("vc-shock");
          document.querySelector('.vc-switch').style["background-color"] = "#04be02";
          document.querySelector('.vc-switch').innerText = "...";
        }, 6000);
      }
    }, 200)
    if (window.oldonerror) {
      window.oldonerror.apply(window, arguments);
    }
    // overlay.showProblems("error", [error.stack || error], true);
  };
}
// emulate touch in desktop mode
if (typeof window.ontouchstart === 'undefined') {
  require("./core/touch-emulate/touch-emulate");
}


header.tabbar = tabbar;
let mainPagePath = routes[0].path.replace('/:pagetime?', '');
let rootContainer = document.querySelector('#container');
const currentPages = router.currentPages || [];
router.currentPages = currentPages;
let pageInstance = '_react_page_route_wrapper_';


window.getCurrentReactPages = function () {
  let pages = [];
  currentPages.forEach((page) => {
    pages.push(page);
  });
  return pages;
};

window.getCurrentReactPage = function () {
  return _.last(currentPages);
};

window.getCurrentPages = function () {
  let pages = [];
  currentPages.forEach((page) => {
    pages.push(page.wxPageDeclaration);
  });
  return pages;
};

function renderComponent(component, target, id, action, path) {

  if (tabbar.isTabPage(path)) {
    let oldPageContainer = target.parentElement.querySelector('.current_page');
    if (oldPageContainer != null && oldPageContainer != target) {
      oldPageContainer.classList.remove('current_page');
    }
    target.classList.add('current_page');
    renderTabPage(component, target, id, action, path);
  } else {
    /*
    if (action == "PUSH" && document.querySelectorAll("#container>.page_container").length > 1) {
      target.classList.add("page-from-right-to-center");
      target.parentElement.classList.add("page-animationing");
      animationEnd(target, function () {
        target.classList.add('current_page');
        target.classList.remove("page-from-right-to-center");
        target.parentElement.classList.remove("page-animationing");
      });
    } else {
      target.classList.add('current_page');
    }
    */
    renderPage(component, target, id, action, path);
  }
}

function renderTabPage(component, target, id, action, path) {
  let currentPage = last(currentPages);
  let page;


  if (currentPage && tabbar.isTabPage(currentPage.wxPageDeclaration.route)) {
    if (currentPage.onHide && (typeof currentPage.onHide == "function")) {
      currentPage.onHide();
    }
  }
  let isNewTab = false;
  if (target[pageInstance]) {
    page = target[pageInstance];
  } else {
    isNewTab = true;
    page = ReactDOM.render(React.createElement(
      PullDownRefresh, null, component
    ), target).page;
    page.wxPageDeclaration.route = path.replace(/^\//, "");
    // 页面page的background-color配置在这里处理
    let backgroundColor = page.getPageConfig('backgroundColor');
    target.style.cssText = `background-color: ${backgroundColor};`;
    target[pageInstance] = page;
  }
  page.pageId = id;
  // clean array
  currentPages.splice(0);
  currentPages.push(page);

  // TODO:提前获取配置信息
  header.show(page.getPageConfig());
  tabbar.show(path, page.getPageConfig());
  if (isNewTab && page.onLoad && (typeof page.onLoad == "function")) {
    page.onLoad(page.props.options);
  }
  if (page.onShow && (typeof page.onShow == "function")) {
    page.onShow();
  }
  if (isNewTab && page.onReady && (typeof page.onReady == "function")) {
    page.onReady();
  }
}


function renderPage(component, target, id, action, path) {
  let page;
  // 兼容swatchTab情况
  if (action === "POP") {
    page = target[pageInstance];
  } else {
    page = ReactDOM.render(React.createElement(
      PullDownRefresh, null, component
    ), target).page;
    page.wxPageDeclaration.route = path.replace(/^\//, "");
    // 页面page的background-color配置在这里处理
    let backgroundColor = page.getPageConfig('backgroundColor');
    target.style.cssText = `background-color: ${backgroundColor};`;
    target[pageInstance] = page;
  }

  page.pageId = id;
  if (action === "PUSH") {
    let currentPage = last(currentPages);

    if (currentPage) {
      let pid = currentPage.pageId;
      if (currentPage.onHide && (typeof currentPage.onHide == "function")) {
        currentPage.onHide();
      }
      page.pagePid = pid;
    } else {
      //首页提前渲染
      target.classList.add('current_page');
    }
    currentPages.push(page);


    if (page.onLoad && (typeof page.onLoad == "function")) {
      page.onLoad(page.props.options);
    }
    if (page.onShow && (typeof page.onShow == "function")) {
      page.onShow();
    }

    animationEnd(target, function () {
      //console.log("animi end");
      // TODO:提前获取配置信息
      header.show(page.getPageConfig());
      let oldPageContainer = target.parentElement.querySelector('.current_page');
      if (oldPageContainer != null && oldPageContainer != target) {
        oldPageContainer.classList.remove('current_page');
      }
      target.classList.add('current_page');
      target.classList.remove("page-from-right-to-center");

      target.parentElement.classList.remove("page-animationing");
      if (page.onReady && (typeof page.onReady == "function")) {
        page.onReady();
      }
      tabbar.show(path, page.getPageConfig());
    });
    target.classList.add("page-from-right-to-center");
    target.parentElement.classList.add("page-animationing");
  } else if (action === "REPLACE") {
    let currentPage = last(currentPages);
    page.pagePid = currentPage.pagePid;
    currentPages.splice(-1);
    currentPages.push(page);
    // TODO:提前获取配置信息
    header.show(page.getPageConfig());
    tabbar.show(path, page.getPageConfig());
    target.classList.add('current_page');
  } else if (action === "POP") {
    currentPages.splice(-1);
    // currentPages = dropRight(currentPages);
    let currentPage = last(currentPages);
    if (currentPage) {
      page.pagePid = currentPage.pagePid;
      currentPages.splice(-1);
      // currentPages = dropRight(currentPages);
    }
    currentPages.push(page);
    // TODO:提前获取配置信息
    header.show(page.getPageConfig());
    tabbar.show(path, page.getPageConfig());
    target.classList.add('current_page');
  }

}

function createPageContainer(id, src, hidden, external = false) {
  let el = document.querySelector(`#${id}`);
  if (el) {
    return el;
  }
  if (external) {
    el = document.createElement('iframe');
    el.setAttribute('src', src);
    el.setAttribute('frameborder', "0");
  } else {
    el = document.createElement('div');
  }
  el.classList.add('page_container');
  el.classList.add('WxPage');
  el.setAttribute('id', id);
  el.setAttribute('width', hidden ? "0" : "100%");
  el.setAttribute('height', hidden ? "0" : "100%");
  if (hidden) {
    el.setAttribute('style', 'width:0;height:0;border:0; display:none;')
  }
  rootContainer.appendChild(el);
  return el
}

// Find and render a web page matching the current URL path,
// if such page is not found then render an error page (see routes.json,
// core/router.js)
// listen tabbar route
function render(location, action = "PUSH") {
  let path = location.pathname.replace(/\/[0-9]+$/, '');
  let oldPageContainer = document.querySelector('#container>.current_page');
  let id;
  let pid;
  let newPageContainer;
  router.resolve(location).then((component) => {
    let currentPage = last(currentPages);
    //tabbar.show(path);
    if (action == "POP") {
      // 获取要返回的节点
      let pid = currentPage.pagePid;
      let pagePath = history.location.pathname.replace(/\/[0-9]+$/, '');
      let pages = document.querySelectorAll(`#container>[data-page-path='${pagePath}']`);
      // 兼容手动修改hash之后 historylib认为pop的情况
      if (pages.length == 0) {
        action = "PUSH";
      } else {
        newPageContainer = last(pages);
        if (!newPageContainer) {
          newPageContainer = document.querySelector(`#container>.main_page`);
        }
      }
    }

    if (action == "POP" || action == "REPLACE") {
      // 销毁react节点 销毁current_page
      if (oldPageContainer && oldPageContainer != newPageContainer) {
        oldPageContainer.parentElement.classList.add("page-animationing");
        oldPageContainer.classList.add("page-from-center-to-right");
        animationEnd(oldPageContainer, function () {
          if (oldPageContainer.parentElement) {
            oldPageContainer.parentElement.classList.remove("page-animationing");
          }
          ReactDOM.unmountComponentAtNode(oldPageContainer);
          oldPageContainer.remove();
          let page = newPageContainer[pageInstance];
          if (action == "REPLACE") {
            if (page.onLoad && (typeof page.onLoad == "function")) {
              page.onLoad(page.props.options);
            }
            if (page.onShow && (typeof page.onShow == "function")) {
              page.onShow();
            }
            if (page.onReady && (typeof page.onReady == "function")) {
              page.onReady();
            }
          } else if (action == "POP") {
            if (page.onShow && (typeof page.onShow == "function")) {
              page.onShow();
            }
          }
        });
      }
    } else if (action == "PUSH" && oldPageContainer) {

      // 兼容swatchTab的情况
      if (tabbar.isTabPage(path)) {
        let tabPage = document.querySelector(`#container>[data-page-path='${path}']`);
        if (tabPage) {
          newPageContainer = tabPage;
          // 销毁react节点 销毁current_page
          let oldPagePath = oldPageContainer.getAttribute("data-page-path");
          if (oldPageContainer && !tabbar.isTabPage(oldPagePath)) {
            ReactDOM.unmountComponentAtNode(oldPageContainer);
            oldPageContainer.remove();
          }
        }
      }
    }

    /*
	 * if(document.querySelectorAll('#container>div').length > 5){ throw new
	 * Error("打开页面层次太深，超过最大深度：5"); }
	 */
    // 维护不同情况的id 和pid
    if (!newPageContainer) {
      id = uniqueId('page_' + path.replace(/\//g, "_"));
      newPageContainer = createPageContainer(id);
    } else {
      id = newPageContainer.getAttribute('id');
    }
    if (path === mainPagePath) {
      newPageContainer.classList.add('main_page');
    }
    if (tabbar.isTabPage(path)) {
      newPageContainer.classList.add('tab_page');
    }
    newPageContainer.setAttribute("data-page-path", path);
    return component;
  })
    .then((component) => renderComponent(component, newPageContainer, id, action, path)).catch((data)=>{
  });
}

function init() {
  offlineRuntime.install();
  if(window.isMicroService){
    //微服务模式，默认首页必须是门户的默认页面，登录后再跳转到期望跳转的页面
    let initUrl = location.hash.substring(1);
    window.microService.initUrl = initUrl;
    history.replace(mainPagePath);
  }else{
    if (history.location.pathname === "/") {
      //兼容参数中main传递首页地址的情况
      let _mainPagePath = new URI(location.href).query(true).main;
      if(_mainPagePath){
        mainPagePath = _mainPagePath;
      }
      history.replace(mainPagePath);
    }
  }

  tabbar.reset();
  if (isX5App) {
    document.addEventListener('deviceready', function () {
      render(history.location);
    }, false);
  } else {
    render(history.location);
  }
  history.listen(render);
// Eliminates the 300ms delay between a physical tap
// and the firing of a click event on mobile browsers
// https://github.com/ftlabs/fastclick
  if (navigator.platform != "Win32") {
    FastClick.attach(document.querySelector('#container'));
    FastClick.attach(document.querySelector('#header'));
    FastClick.attach(document.querySelector('#tabbar'));
  }
// prevent longtap context menu
  document.body.addEventListener('contextmenu', function (e) {
    e.preventDefault();
  });

  window.addEventListener('message', function (event) {
    if (event.data && event.data.type == "hash") {
      let hash = event.data.hash;
      if (hash) {
        window.location.hash = hash;
      }
    }
  });
  window.inited = true;
}


if (!window.inited) {
  init();
}
// Enable Hot Module Replacement (HMR)
if (module.hot) {
  module.hot.accept();
  module.hot.addStatusHandler(status => {
    let vcSwitch = document.querySelector('.vc-switch');
    // 响应当前状态……
    if (status == "check") {
      if (window.resetHotTimer) {
        clearTimeout(window.resetHotTimer);
      }
      window.hotSwaping = true;
    } else if (status == "idle") {
      routes = require('./routes.json');
      window.routes = routes;
      if (vcSwitch) {
        vcSwitch.innerText = "...";
        vcSwitch.classList.remove("vc-hmr");
      }
      // wait for page reRender finished
      window.resetHotTimer = setTimeout(function () {
        window.hotSwaping = false;
        window.resetHotTimer = null;
      }, 500);
    }
  });
}



// WEBPACK FOOTER //
// ./main.js